import { Toaster } from "@arcadeai/design-system/components/ui/molecules/toast";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { posthog } from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { DevTools } from "@/components/custom/dev-tools";
import { StrongAuthGate } from "@/components/custom/strong-auth-gate";
import { StrongAuthRequired } from "@/components/custom/strong-auth-required";
import { queryClient } from "./lib/query-client";
import { router } from "./router";

const Providers = () => {
  return (
    <PostHogProvider client={posthog}>
      <QueryClientProvider client={queryClient}>
        <Toaster />
        <StrongAuthRequired />
        <StrongAuthGate>
          <RouterProvider router={router} />
        </StrongAuthGate>
        <DevTools />
      </QueryClientProvider>
    </PostHogProvider>
  );
};

export default Providers;
